import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const RefundPolicy = () => {

    const location = useLocation();

    useEffect(() => {
      // Remove modal backdrops
      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((el) => el.remove());
  
      // Remove modal-open class
      document.body.classList.remove("modal-open");
  
      // Remove inline styles like overflow and padding
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
  
      // Optionally, clear all inline styles (use with caution)
      // document.body.removeAttribute("style");
    }, [location]);


    return (
      <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-sm">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">
          Refund Policy
        </h2>
    
        <ul className="list-disc ml-5 space-y-3 text-gray-700 leading-relaxed">
          <li>
            For refunds, please contact the respective outlet and also mail us at{" "}
            <a
              href="mailto:support@apmsmarthub.com"
              className="text-blue-600 hover:underline font-medium"
            >
              support@apmsmarthub.com
            </a>{" "}
            or call us at{" "}
            <a
              href="tel:+919481699771"
              className="text-blue-600 hover:underline font-medium"
            >
              +91 94816 99771
            </a>.
          </li>
    
          <li>
            In case of dissatisfaction with our service, customers are requested
            to write to{" "}
            <a
              href="mailto:support@apmsmarthub.com"
              className="text-blue-600 hover:underline font-medium"
            >
              support@apmsmarthub.com
            </a>.
          </li>
    
          <li>
            Goods purchased can be returned within seven (07) days from the date of purchase
            with the original bill, subject to outlet approval.
          </li>
    
          <li>
            If payment is made via credit card, the eligible refund amount
            will be reversed to the same credit card upon approval.
          </li>
    
          <li>
            Partial payments or transactions made outside the app are not eligible for refunds.
          </li>
    
          <li>
            In case of refund requests, reward points earned on that transaction
            will be reversed.
          </li>
        </ul>
      </div>
    );
    
};

export default RefundPolicy;
